import { render, staticRenderFns } from "./agreementHint.vue?vue&type=template&id=215c869a&scoped=true"
import script from "./agreementHint.vue?vue&type=script&lang=js"
export * from "./agreementHint.vue?vue&type=script&lang=js"
import style0 from "./agreementHint.vue?vue&type=style&index=0&id=215c869a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215c869a",
  null
  
)

export default component.exports